import { registerTour } from "../tourRegistry";

function getSteps() {
  const totalSteps = 4;
  const stepCounter = (n) => `Step ${n} of ${totalSteps}`;

  return [
    {
      id: 'history-overview',
      title: `Audit Log <span class="t3-shepherd-step-count">${stepCounter(1)}</span>`,
      text: 'Every change in your organization is recorded here \u2014 transaction creates, edits, deletes, account changes, fund updates, and more. This is your complete audit trail.',
      attachTo: { element: '[data-tour="history-page"]', on: 'bottom' },
      buttons: [
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'history-filters',
      title: `Filters <span class="t3-shepherd-step-count">${stepCounter(2)}</span>`,
      text: 'Filter by document type (transactions, accounts, funds, etc.), action type (create, update, delete), or specific user. Combine filters to find exactly what you\'re looking for.',
      attachTo: { element: '[data-tour="history-filters"]', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'history-list',
      title: `Change History <span class="t3-shepherd-step-count">${stepCounter(3)}</span>`,
      text: 'Each entry shows who made a change, when, and what was modified. Click any entry to see the full before-and-after comparison.',
      attachTo: { element: '[data-tour="history-list"]', on: 'top' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'history-detail',
      title: `Change Details <span class="t3-shepherd-step-count">${stepCounter(4)}</span>`,
      text: 'The detail view shows a side-by-side comparison of the old and new values. For transactions, you\'ll see exactly which fields changed \u2014 amounts, accounts, funds, dates, and more.',
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Done',
          classes: 't3-shepherd-next-btn',
          action() { this.complete(); },
        },
      ],
    },
  ];
}

registerTour({
  id: 'history',
  pathPattern: '/history',
  getSteps,
  label: 'Audit Log Tour',
});
